import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'
import { fonts } from 'component-library/__styling/settings'

export const StyledMoreTitle = styled('h2')({
    fontSize: calcRem(18),
    fontFamily: fonts.sevennews.sansSerifCond,
    textTransform: 'uppercase',
    marginBottom: calcRem(18),
})
